import React, {useEffect} from 'react'
import {useFormContext} from "react-hook-form";
import cn from "classnames";
import {Loader} from "react-feather";
import {
    normalizeCepNumber,
    normalizeCnpjNumber,
    normalizeCpfCnpjNumber, normalizeCpfNumber,
    normalizeHumanDate,
    normalizePhoneNumber, normalizeToLowerCase,
    normalizeToUpperCase
} from "../../util/Masks";
import {labelSizeClass} from "./labelSize";

export default function UiInputText({ label, name, size, labelSize, mask, linkComponent, prependElements, appendElements, showDisableCheckbox, onDisableSetValue, disableButtonLabel, asTable, loading, ...rest }: any){
    const formContext = useFormContext();
    const { register } = formContext;
    const LinkComponent = linkComponent as JSX.Element;

    const value = formContext.watch(name);
    const isDisabled = formContext.watch(`${name}_disabled`);
    useEffect(() => {
        if(onDisableSetValue) {
            if (isDisabled) {
                formContext.setValue(name, onDisableSetValue);
            }else if(value == onDisableSetValue){
                formContext.setValue(name, '');
            }
        }
    }, [ isDisabled ]);

    useEffect(() => {
        if(mask){
            switch(mask){
                case 'phone':
                    formContext.setValue(name, normalizePhoneNumber(value))
                    break;
                case 'date':
                    formContext.setValue(name, normalizeHumanDate(value))
                    break;
                case 'cep':
                    formContext.setValue(name, normalizeCepNumber(value))
                    break;
                case 'cpfCnpj':
                    formContext.setValue(name, normalizeCpfCnpjNumber(value))
                    break;
                case 'cpf':
                    formContext.setValue(name, normalizeCpfNumber(value))
                    break;
                case 'cnpj':
                    formContext.setValue(name, normalizeCnpjNumber(value))
                    break;
                case 'uppercase':
                    formContext.setValue(name, normalizeToUpperCase(value))
                    break;
                case 'lowercase':
                    formContext.setValue(name, normalizeToLowerCase(value))
                    break;
            }
        }
    }, [ value ]);


    return (
        <div className={cn(`col-lg-${(size) ? size : 12}`, `ui-input-text`, {
            'with-append': showDisableCheckbox
        })}>
            <div className={`form-item${labelSizeClass(labelSize)}`}>
                { !asTable &&
                    <label className="form-label">{label}{
                        LinkComponent &&
                        // @ts-ignore
                        <LinkComponent formContext={formContext} name={name}/>
                    }
                    </label>
                }
                <div className={cn("field-container", {
                    'with-spinner': loading
                })}>
                    { prependElements && prependElements(`${name}`, formContext) }
                    <input disabled={isDisabled} type="text" className="form-control" {...register(name)} {...rest} />
                    { loading &&
                        <span className="input-loading-spinner">
                            <Loader
                                size={16}
                                style={{
                                    animation: 'spin 1s linear infinite',
                                    color: '#0d6efd'
                                }}
                            />
                        </span>
                    }
                    { showDisableCheckbox &&
                        <label className="form-append">
                            <input type="checkbox" className="form-check-input" {...register(`${name}_disabled`)} />
                            { disableButtonLabel ? disableButtonLabel : `N/A` }
                        </label>
                    }
                    { appendElements && appendElements(`${name}`, formContext) }
                </div>
            </div>
        </div>
    )
}